import { ApiService } from './ApiService';
import { Result, ResultOf } from '@/types/result';
import { AddCardFormModel } from '@/pages/Subscription/types/AddCardModel';
import { AddCardResponseModel } from '@/pages/Subscription/types/AddCardResponseModel';
type PaymentId = number;
export class PaymentsApi extends ApiService {
    base = 'Payments';
    async addCard(data: AddCardFormModel): Promise<ResultOf<AddCardResponseModel>> {
        return await this.post(this.getUrl('AddCard'), data);
    }
    async retryPayment(userId: number): Promise<ResultOf<PaymentId>> {
        return await this.get(this.getUrl('RetryPayment'), { userId });
    }
    /** Удалить сохранённую карту (FINCH-2543): и PRO, и платных функций/пакетов — после удаления списаний по ней не будет */
    async deleteCard(): Promise<Result> {
        return await this.post(this.getUrl('DeleteCard'));
    }
}
